/**
 * Collection of route constants for the project.
 * This file contains the paths used in the application routing.
 */

export type RoutePaths = (typeof ROUTES)[keyof typeof ROUTES];

const ROUTES = {
	MAIN: "/",
	LOGIN: "/login",
	ORDERS: "/orders",
	ACCOUNTING: "/accounting",
	ACCOUNTS: "/accounts",
	ARCHIVES: "/archives",
	RATINGS: "/ratings",
	REPORTS: "/reports",
	CUSTOMERS: "/customers",
	BLACKLIST: "/blacklist",
	PREFERENCES: "/preferences",
	SETTINGS: "/settings",

	// ? settings part
	SETTINGS_ORDERS: "/settings/orders",
	SETTINGS_TARIFFS: "/settings/tariffs",
	SETTINGS_FINANCES: "/settings/finances",
	SETTINGS_MESSAGES: "/settings/messages",
	SETTINGS_MOBILE_APPS: "/settings/mobile-apps",
	SETTINGS_PARAMETERS: "/settings/parameters",
	SETTINGS_MAP: "/settings/map",
	SETTINGS_ORDER_EXCHANGE: "/settings/order-exchange",
	SETTINGS_PAYMENT_SYSTEMS: "/settings/payment-systems",
	SETTINGS_RECEIPT_PROVIDERS: "/settings/receipt-providers",
	SETTINGS_INTERFACE: "/settings/interface",
	SETTINGS_VOIP: "/settings/voip",
	SETTINGS_CAR_PARKS: "/settings/carParks",
	SETTINGS_SYSTEM_PERFORMANCE: "/settings/system-performance",

	// ? reports part
	REPORTS_CHARTS: "/reports/charts",
	REPORTS_ACCOUNTING: "/reports/accounting",
	REPORTS_SALARY: "/reports/salary",
	REPORTS_DETAILS: "/reports/details",
} as const;

const OPEN_ROUTES: RoutePaths[] = [ROUTES.LOGIN];
const ADMIN_ROUTES: RoutePaths[] = [];

// type TabKeysForRoute = {
// 	[key in RoutePaths]: { [key: string]: string };
// };

const TABS /* : TabKeysForRoute  */ = {
	[ROUTES.PREFERENCES]: {
		SETTINGS_CAR_MODELS_AND_BRANDS: "settingsCarModelsAndBrands",
		CAR_CLASSES: "carClasses",
		COLORS: "colors",
		OBJECTS: "objects",
		SECTORS: "sectors",
		PARKINGS: "parkings",
		PRICE_ZONES: "priceZones",
		SERVICES: "services",
		CLIENT_REFUSAL_REASONS: "clientRefusalReasons",
	},
	[ROUTES.ARCHIVES]: {
		ORDERS: "orders",
		BANK_TRANSACTIONS: "bankTransactions",
		TRANSACTIONS: "transactions",
		GPS_LOG: "gpsLog",
		MESSAGES: "messages",
		PUSH: "push",
		CALLS_HISTORY: "callsHistory",
		RECEIPTS_HISTORY: "receiptsHistory",
	},
	[ROUTES.RATINGS]: {
		EXECUTORS: "executors",
	},
	// TODO DP Complete the rest of the page tabs
	[ROUTES.MAIN]: {},
	[ROUTES.LOGIN]: {},
	[ROUTES.ORDERS]: {},
	[ROUTES.ACCOUNTING]: {},
	[ROUTES.ACCOUNTS]: {},
	[ROUTES.REPORTS]: {},
	[ROUTES.CUSTOMERS]: {},
	[ROUTES.BLACKLIST]: {},
	[ROUTES.SETTINGS]: {},
	[ROUTES.SETTINGS_ORDERS]: {},
	[ROUTES.SETTINGS_TARIFFS]: {},
	[ROUTES.SETTINGS_FINANCES]: {},
	[ROUTES.SETTINGS_MESSAGES]: {},
	[ROUTES.SETTINGS_MOBILE_APPS]: {},
	[ROUTES.SETTINGS_PARAMETERS]: {},
	[ROUTES.SETTINGS_MAP]: {},
	[ROUTES.SETTINGS_ORDER_EXCHANGE]: {},
	[ROUTES.SETTINGS_PAYMENT_SYSTEMS]: {},
	[ROUTES.SETTINGS_RECEIPT_PROVIDERS]: {},
	[ROUTES.SETTINGS_INTERFACE]: {},
	[ROUTES.SETTINGS_VOIP]: {},
	[ROUTES.SETTINGS_CAR_PARKS]: {},
	[ROUTES.SETTINGS_SYSTEM_PERFORMANCE]: {
		OVERVIEW: "overview",
		INCIDENTS: "incidents",
		OPERATIONS: "operations",
	},
	[ROUTES.REPORTS_CHARTS]: {},
	[ROUTES.REPORTS_ACCOUNTING]: {},
	[ROUTES.REPORTS_SALARY]: {},
	[ROUTES.REPORTS_DETAILS]: {},
} as const;

export { ROUTES, OPEN_ROUTES, ADMIN_ROUTES, TABS };
